import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const ManageWatchlistSkeleton = () => {
  return (
    <div style={{ padding: '10px 24px' }}>
      <Skeleton height={50} style={{ backgroundColor: '#e0e0e0' }} />

      <Skeleton variant="rect" height={500} style={{ backgroundColor: '#e0e0e0' }} />

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Skeleton width={100} height={50} style={{ backgroundColor: '#e0e0e0' }} />
      </div>
    </div>
  );
};

export default ManageWatchlistSkeleton;
